// extracted by mini-css-extract-plugin
var _1 = "EntityProfileHeaderTitleWithStatus-moduleEntityProfileHeaderTitleWithStatus__vrABE";
var _2 = "EntityProfileHeaderTitleWithStatus-moduleactions___3aaa";
var _3 = "EntityProfileHeaderTitleWithStatus-moduleavatarWrapper__dqG1L";
var _4 = "EntityProfileHeaderTitleWithStatus-modulebackButton__FR599 EntityProfileHeaderTitleBackButton-moduleEntityProfileHeaderTitleBackButton__c_PKq";
var _5 = "EntityProfileHeaderTitleWithStatus-moduleopen__UdVwZ";
var _6 = "EntityProfileHeaderTitleWithStatus-modulestatus__Wj1In";
var _7 = "EntityProfileHeaderTitleWithStatus-modulestatusTag__T452w";
var _8 = "EntityProfileHeaderTitleWithStatus-modulestatusText__bJwX_ TagContent-moduletext__PX78H";
var _9 = "EntityProfileHeaderTitleWithStatus-moduletitleContent__rDoaA";
var _a = "EntityProfileHeaderTitleWithStatus-modulewithoutBackButton__Mt3oX";
export { _1 as "EntityProfileHeaderTitleWithStatus", _2 as "actions", _3 as "avatarWrapper", _4 as "backButton", _5 as "open", _6 as "status", _7 as "statusTag", _8 as "statusText", _9 as "titleContent", _a as "withoutBackButton" }
